import { ca } from '@cian/analytics';

type TNewbuildingComparisonAction = 'Add' | 'Remove' | 'click_popup_add' | 'click_popup_remove';

/**
 * Источник совершения действия — разделяет точки добавления в сравнение на карточке ЖК:
 * header — заголовок КаЖК, ask_author — блок «Спросите застройщика», about_building — блок «О ЖК».
 */
export type TComparisonEventSource = 'header' | 'ask_author' | 'about_building';

function trackNewbuildingComparisonEvent(
  newbuildingId: number,
  action: TNewbuildingComparisonAction,
  label: string,
  source?: TComparisonEventSource,
) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action,
    label,
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
    ...(source && { page: { extra: { source } } }),
  });
}

export function trackAddNewbuildingToComparison(
  newbuildingId: number,
  gaLabel: string,
  source: TComparisonEventSource,
) {
  trackNewbuildingComparisonEvent(newbuildingId, 'Add', gaLabel, source);
}

export function trackRemoveNewbuildingFromComparison(
  newbuildingId: number,
  gaLabel: string,
  source: TComparisonEventSource,
) {
  trackNewbuildingComparisonEvent(newbuildingId, 'Remove', gaLabel, source);
}

export function trackClickAddComparisonPopup(newbuildingId: number, source: TComparisonEventSource) {
  trackNewbuildingComparisonEvent(newbuildingId, 'click_popup_add', 'to_compare', source);
}

export function trackClickRemoveComparisonPopup(newbuildingId: number, source: TComparisonEventSource) {
  trackNewbuildingComparisonEvent(newbuildingId, 'click_popup_remove', 'to_compare', source);
}
